import Raven from 'raven-js'

import * as mutation from './mutationTypes'

import {
  defaultState,
} from './state'

const mutations = {
  addTeams (state, teams) {
    state.teams = teams
  },
  addTeam (state, team) {
    state.teams =
      state.teams
      .filter(x => x.id !== team.id)
      .concat(team)
  },
  removeTeam (state, teamID) {
    state.teams = state.teams.filter(x => x.id !== teamID)
  },
  setLoadingTeamData (state, value) {
    state.loadingTeamData = value
  },
  setShowAddVideoModal (state, value) {
    state.showAddVideoModal = value
  },
  toggleShowShareModal (state) {
    state.showShareModal = !state.showShareModal
  },
  closeShareModal (state) {
    state.showShareModal = false
  },
  toggleShowAddUserModal (state) {
    state.showAddUserModal = !state.showAddUserModal
  },
  toggleShowAddFileModal (state) {
    state.showAddFileModal = !state.showAddFileModal
    state.errorAddingFile = false
  },
  setAddingFile (state, val) {
    state.addingFile = val
  },
  setShowAddToVideoModal (state, val) {
    state.showAddToVideoModal = val
  },
  // for adding a resource to a video
  addFile (state, { videoID, resource }) {
    state.resources =
      state.resources.filter(x => x.id !== resource.id).concat(resource)

    // messy mainly because resources are not objects, they should be
    state.videos = {
      ...state.videos,
      [videoID]: {
        ...state.videos[videoID],
        resources: state.videos[videoID].resources != null
          ? state.videos[videoID].resources.filter(x => x.id !== resource.id).concat(resource)
          : [resource]
      }
    }
  },
  setErrorAddingFile (state, value) {
    state.errorAddingFile = value
  },

  notify (state, { message, level = 'info', sticky = false }) {
    state.notification.message = message
    state.notification.show = true
    state.notification.level = level
    state.notification.sticky = sticky
  },
  notifyClose (state) {
    state.notification.show = false
  },
  authenticateUser (state, { user, token }) {
    localStorage.setItem('token', token)
    state.user = { ...state.user, ...user, authenticated: true }
    if (user != null) {
      Raven.setUserContext({ email: user.email })
    }
    state.flags = user && user.flags
  },
  setLoginErrorMessage (state, message) {
    state.loginErrorMessage = message
  },

  setErrorSocialLogin (state, { email, nonFieldErrors }) {
    if (email == null) {
      email = []
    }
    if (nonFieldErrors == null) {
      nonFieldErrors = []
    }
    state.socialLoginErrors = { ...state.socialLoginErrors, ...{ email, nonFieldErrors } }
  },

  [mutation.updateSocialConnections] (state, connections) {
    state.socialAccountConnections = {
      ...state.socialAccountConnections,
      ...connections.reduce((acc, { provider, id }) => {
        acc[provider] = id
        return acc
      }, {})
    }
  },

  [mutation.removeProviderByID] (state, providerID) {
    const connectionsCopy = Object.assign({}, state.socialAccountConnections)
    Object.keys(connectionsCopy).forEach((key, _index) => {
      if (connectionsCopy[key] === providerID) {
        connectionsCopy[key] = null
      }
    })
    state.socialAccountConnections = {
      ...state.socialAccountConnections,
      ...connectionsCopy
    }
  },

    /**
   * Update user state.
   *
   * @param {Object} user - User object containing data to add to store
   */
  updateUser (state, user) {
    state.user = { ...state.user, ...user }
  },

  logout (state) {
    localStorage.removeItem('token')
    // a hack to reset state since just setting state to defaultState doesn't work
    for (const key in state) {
      state[key] = defaultState[key]
    }
  },

  setVideoPlayerSource (sourceURL) {
    const x = document.querySelector('.vjs-tech')
    if (x != null) {
      x.src = sourceURL
    }
  },

  setAddingComment (state, value) {
    state.addingComment = value
  },

  setDisplayAddComment (state, value) {
    state.displayAddComment = value
  },

  setSendingToProcessing (state, value) {
    state.sendingToProcessing = value
  },

  setLoadingVideos (state, value) {
    state.loadingVideos = value
  },

  setLoadingResources (state, value) {
    state.loadingResources = value
  },

  addComment (state, { videoID, newComment }) {
    // need to make sure that vuex sees the state change
    state.videos = {
      ...state.videos,
      [videoID]: {
        ...state.videos[videoID],
        comments: state.videos[videoID].comments
          .filter(x => x.id !== newComment.id)
          .concat(newComment)
      }
    }
  },
  updateComment (state, {
      videoID,
      commentID,
      body,
      end_time,
      start_time,
    }) {
    state.videos[videoID].comments =
      state.videos[videoID].comments.map(comment => {
        if (comment.id === commentID) {
          return {
            ...comment,
            body,
            end_time,
            start_time,
          }
        }
        return comment
      })
  },
  deleteComment (state, { videoID, commentID }) {
    state.videos[videoID].comments =
      state.videos[videoID].comments.filter(x => x.id !== commentID)
  },
  setCommentToActive (state, { videoID, commentID }) {
    state.videos[videoID].comments =
      state.videos[videoID].comments.map(comment => {
        return {
          ...comment,
          active: comment.id === commentID
        }
      })
  },
  updateReply (state, { videoID, commentID, replyID, newReplyBody }) {
    state.videos[videoID].comments.forEach(comment => {
      if (comment.id === commentID) {
        for (const reply of comment.replies) {
          if (reply.id === replyID) {
            reply.body = newReplyBody
          }
        }
      }
    })
  },
  deleteReply (state, { videoID, commentID, replyID }) {
    state.videos[videoID].comments =
      state.videos[videoID].comments.map(comment => {
        if (comment.id === commentID) {
          comment.replies = comment.replies.filter(x => x.id !== replyID)
        }
        return comment
      })
  },
  toggleReplytoComment (state, { videoID, commentID }) {
    // toggles the editing state for replying to a comment
    state.videos[videoID].comments =
      state.videos[videoID].comments.map(x => {
        if (x.id === commentID) {
          x.replies_editing = x.replies_editing != null
              ? !x.replies_editing
              : true
        }
        return x
      })
  },
  setAddingReply (state, val) {
    state.addingReply = val
  },
  // TODO: rename this arg
  addReply (state, { videoID, commentID, newComment }) {
    state.videos[videoID].comments.forEach(comment => {
      if (comment.id === commentID) {
        comment.replies =
          comment.replies
          .filter(x => x.id !== newComment.id)
          .concat(newComment)
      }
    })
  },

  setEmailConfirmed (state, val) {
    state.user.email_confirmed = val
  },

  dismissNotification (state, id) {
    for (const note of state.notifications) {
      if (note.id === id) {
        note.dismissed = true
        return note
      }
    }
  },
  dismissAllNotifications (state) {
    state.notifications = state.notifications.map(x => ({ ...x, dismissed: true }))
  },
  [mutation.addNewNotifications] (state, notifications) {
    notifications.forEach(n => {
      state.notifications.unshift(n)
    })
  },
  updateNotifications (state, notifications) {
    state.notifications = notifications
  },
  [mutation.setMostRecentNotification] (state, val) {
    state.mostRecentNotification = val
  },

  setLoadingNotificationsData (state, value) {
    state.loadingNotificationsData = value
  },

  deleteFile (state, id) {
    state.resources = state.resources.filter(x => x.id !== id)
  },
  updateResources (state, resources) {
    state.resources = resources
  },
  [mutation.setVideo] (state, video) {
    state.videos = {
      ...state.videos,
      [video.id]: video
    }
  },
  updateVideos (state, videos) {
    state.videos =
      videos.reduce((a, b) => ({
        ...a,
        [b.id]: b
      }), state.videos)
  },
  updateVideosSharedWithMe (state, videos) {
    state.videosSharedWithMe = videos
  },

  setLibraries (state, libraries) {
    state.libraries = libraries
  },
  setActiveLibrary (state, library) {
    state.activeLibrary = library
  },
  updateActiveLibrary (state, { title, description }) {
    state.activeLibrary.title = title
    state.activeLibrary.description = description
  },
  setActiveLibraryID (state, id) {
    state.activeLibraryID = id
  },
  setLoadingLibraryData (state, val) {
    state.loadingLibraryData = val
  },
  removeVideoFromLibrary (state, videoID) {
    state.activeLibrary.videos = state.activeLibrary.videos.filter(x => x.id !== videoID)
  },

  // url: /files
  updateFile (state, file) {
    state.resources = state.resources.map(x => {
      if (x.id === file.id) {
        x = file
      }
      return x
    })
  },
  updateFileVideo (state, { videoID, title }) {
    state.videos[videoID].title = title
  },

  updateTeam (state, team) {
    const index = state.teams.findIndex(x => x.id === team.id)
    state.teams[index].name = team.name
    state.teams[index].privacy_setting = team.privacy_setting
  },

  // url: /teams
  toggleTeam (state, id) {
    state.teams = state.teams.map(x => {
      if (x.id === id) {
        x.expanded = x.expanded != null ? !x.expanded : true
      }
      return x
    })
  },
  removeUserFromTeam (state, { teamID, userID }) {
    for (const team of state.teams) {
      if (team.id === teamID) {
        team.members = team.members.filter(x => x.id !== userID)
      }
    }
  },
  addUserToTeam (state, { teamID, user }) {
    for (const team of state.teams) {
      if (team.id === teamID) {
        team.members = team.members.concat(user)
      }
    }
  },
  setAddingUserToTeam (state, val) {
    state.addingUserToTeam = val
  },
  setRemovingUserFromTeam (state, val) {
    state.removingUserFromTeam = val
  },

  updateGroup (state, group) {
    state.group = group
  },
  addUserToGroup (state, user) {
    if (state.group != null) {
      state.group.users = state.group.users.concat(user)
    }
  },
  setLoadingGroup (state, val) {
    state.loadingGroup = val
  },

  updateVideoProcessed (state, { videoID, processed }) {
    state.videos = {
      ...state.videos,
      [videoID]: {
        ...state.videos[videoID],
        processed,
      }
    }
  },

  updateVideo (state, { videoID, newTitle, newDescription }) {
    state.videos[videoID] = {
      ...state.videos[videoID],
      title: newTitle,
      description: newDescription
    }
  },
  deleteVideoByID (state, videoID) {
    delete state.videos[videoID]
  },
  updateVideoShare (state, { videoID, newShare }) {
    state.videos[videoID].shares =
      state.videos[videoID].shares
      .filter(x => x.id !== newShare.id)
      .concat(newShare)
  },
  removeVideoShare (state, { videoID, videoShareID }) {
    state.videos[videoID].shares =
      state.videos[videoID].shares.filter(x => x.id !== videoShareID)
  },
  setUnsharingShare (state, { videoID, videoShareID, val }) {
    state.videos[videoID].shares =
      state.videos[videoID].shares.map(x => {
        if (x.id === videoShareID) {
          return { ...x, unsharing: val }
        }
        return x
      })
  },
  setUnsharingTeamShare (state, { videoID, teamShareID, val }) {
    state.videos[videoID].teamshares =
      state.videos[videoID].teamshares.map(x => {
        if (x.id === teamShareID) {
          return { ...x, unsharing: val }
        }
        return x
      })
  },
  updateTeamShare (state, { videoID, newTeamShare }) {
    state.videos[videoID].teamshares =
      state.videos[videoID].teamshares
      .filter(x => x.id !== newTeamShare.id)
      .concat(newTeamShare)
  },
  removeTeamShare (state, { videoID, teamShareID }) {
    state.videos[videoID].teamshares =
      state.videos[videoID].teamshares.filter(x => x.id !== teamShareID)
  },
  updateVideoSlugSharing (state, { videoID, val }) {
    state.videos[videoID].slug_share_enabled = val
  },
  updateVideoCommenting (state, { videoID, commenting }) {
    state.videos[videoID].commenting = commenting
  },

  setClippingVideo (state, value) {
    state.clippingVideo = value
  },

  deleteResource (state, { videoID, resourceID }) {
    state.resources = state.resources.filter(x => x.id !== resourceID)
    state.videos[videoID].resources =
      state.videos[videoID].resources.filter(x => x.id !== resourceID)
  },
  updateResource (state, { videoID, resourceID, newTitle }) {
    state.videos[videoID].resources.forEach(x => {
      if (x.id === resourceID) {
        x.title = newTitle
      }
    })
  },

  [mutation.addVideo] (state, newVideo) {
    // not returned by serializer so we set the comments & resources to empty
    // arrays to prevent breakage down the road
    // TODO: this could be improved by using a different serializer for
    // returning the response the create() method
    state.videos[newVideo.id] = {
      ...newVideo,
      comments: [],
      resources: [],
      user: state.user
    }
  },
  updateActiveExercise (state, exercise) {
    state.activeExercise = exercise
  },
  updateExercises (state, exercises) {
    state.exercises = exercises
  },
  addExercise (state, exercise) {
    state.exercises.push(exercise)
  },
  setLoadingExercises (state, val) {
    state.loadingExercises = val
  },
  setSavingExercise (state, val) {
    state.savingExercise = val
  },
  updateExercise (state, exercise) {
    state.exercises = state.exercises
      .filter(x => x.id !== exercise.id)
      .concat(exercise)
  },
  toggleSelectedExerciseQuestionOption (state, { exerciseID, optionID }) {
    for (const exercise of state.exercises) {
      if (exercise.id === exerciseID) {
        for (const question of exercise.questions) {
          if (question.rubric_element == null) continue

          question.rubric_element.descriptors = question.rubric_element.descriptors.map(x => {
            if (x.id === optionID) {
              x.selected = !x.selected
            } else {
              x.selected = false
            }
            return x
          })
        }
      }
    }
  },
  setSavingResponse (state, val) {
    state.savingResponse = val
  },
  saveResponse (state, { exerciseID, questionID, answer }) {
    const exercise = state.exercises.find(x => x.id === exerciseID)
    if (exercise == null) return
    exercise.questions = exercise.questions.map(question => {
      if (question.id === questionID) {
        return Object.assign({}, question, { answer })
      }
      return question
    })
  },
  setUpdatingResponse (state, val) {
    state.updatingResponse = val
  },
  updateResponse (state, { exerciseID, questionID, data }) {
    const exercise = state.exercises.find(x => x.id === exerciseID)
    if (exercise == null) return
    exercise.questions = exercise.questions.map(question => {
      if (question.id === questionID) {
        // update the question & update the question's answer
        return Object.assign({}, question, {
          answer: Object.assign({}, question.answer, data),
        })
      }
      return question
    })
  },

  updateRubricElements (state, val) {
    state.rubricElements = val
  },
  setLoadingRubricElements (state, val) {
    state.loadingRubricElements = val
  },
  setAddingRubricElementtoComment (state, val) {
    state.addingRubricEementtoComment = val
  },
  addRubricElementtoComment (state, { videoID, commentID, rubricElement }) {
    state.videos[videoID].comments =
      state.videos[videoID].comments.map(comment => {
        if (comment.id === commentID) {
          return {
            ...comment,
            tags: comment.tags.filter(x => x.id !== rubricElement.id).concat(rubricElement),
          }
        }
        return comment
      })
  },
  removeRubricElementfromComment (state, { videoID, commentID, rubricElementID }) {
    state.videos[videoID].comments =
      state.videos[videoID].comments.map(comment => {
        if (comment.id === commentID) {
          return {
            ...comment,
            tags: comment.tags.filter(x => x.id !== rubricElementID),
          }
        }
        return comment
      })
  },

  setLoadingFolders (state, val) {
    state.loadingFolders = val
  },
  updateFolders (state, folders) {
    state.folders = folders
  },
  updateSharedFolders (state, sharedFolders) {
    state.sharedFolders = sharedFolders
  },
  addFolder (state, folder) {
    state.folders.push(folder)
  },
  removeFolder (state, folderID) {
    state.folders = state.folders.filter(x => x.id !== folderID)
  },
  updateVideoFolder (state, { videoID, folder }) {
    state.videos[videoID].folder = folder
  },

  addColleague (state, user) {
    state.user.colleagues.push(user)
  },
  removeColleague (state, userID) {
    state.user.colleagues = state.user.colleagues.filter(x => x.id !== userID)
  },

  setLoadingMembers (state, val) {
    state.loadingMembers = val
  },
  updatePendingMembers (state, members) {
    state.pendingMembers = members
  },
  loadingResendEmailConfirmation (state, val) {
    state.loadingResendEmailConfirmation = val
  },

  addInvite (state, invite) {
    state.invites.push(invite)
  },

  updateTags (state, tags) {
    state.tags = tags
  },
  addTag (state, tag) {
    state.tags.push(tag)
  },
  removeTag (state, tagID) {
    state.tags = state.tags.filter(x => x.id !== tagID)
  },
  archiveTag (state, tagID) {
    state.tags.forEach(x => {
      if (x.id === tagID) {
        x.archived = true
      }
    })
  },
  restoreTag (state, tagID) {
    state.tags.forEach(x => {
      if (x.id === tagID) {
        x.archived = false
      }
    })
  },
  updateTagShare (state, { tagID, groupTag }) {
    state.tags.forEach(x => {
      if (x.id === tagID) {
        x.group_tag = groupTag
      }
    })
  },
  updateTag (state, { tagID, title, color }) {
    state.tags.forEach(x => {
      if (x.id === tagID) {
        x.title = title
        x.color = color
      }
    })
  },
  updateRubricItem (state, { rubricID, header1, header2, header3, header4, header5, desc1, desc2, desc3, desc4, desc5 }) {
    state.tags.forEach(x => {
      if (x.rubric && x.rubric.id === rubricID) {
        x.rubric.header1 = header1
        x.rubric.header2 = header2
        x.rubric.header3 = header3
        x.rubric.header4 = header4
        x.rubric.header5 = header5
        x.rubric.desc1 = desc1
        x.rubric.desc2 = desc2
        x.rubric.desc3 = desc3
        x.rubric.desc4 = desc4
        x.rubric.desc5 = desc5
      }
    })
  },
  addTagToComment (state, { videoID, commentID, tag }) {
    state.videos = {
      ...state.videos,
      [videoID]: {
        ...state.videos[videoID],
        comments: state.videos[videoID].comments.map(comment => {
          if (comment.id === commentID) {
            return {
              ...comment,
              tags: comment.tags.filter(x => x.id !== tag.id).concat(tag),
            }
          }
          return comment
        })
      }
    }
  },
  removeTagFromComment (state, { videoID, commentID, tagID }) {
    state.videos = {
      ...state.videos,
      [videoID]: {
        ...state.videos[videoID],
        comments: state.videos[videoID].comments.map(comment => {
          if (comment.id === commentID) {
            return {
              ...comment,
              tags: comment.tags.filter(x => x.id !== tagID)
            }
          }
          return comment
        })
      }
    }
  },
  addScoreToComment (state, { score, videoID, commentID }) {
    state.videos = {
      ...state.videos,
      [videoID]: {
        ...state.videos[videoID],
        comments: state.videos[videoID].comments.map(comment => {
          if (comment.id === commentID) {
            return {
              ...comment,
              scores: comment.scores.filter(x => x.tag !== score.tag).concat(score),
            }
          }
          return comment
        })
      }
    }
  },
  removeScoreFromComment (state, { scoreID, videoID, commentID }) {
    state.videos = {
      ...state.videos,
      [videoID]: {
        ...state.videos[videoID],
        comments: state.videos[videoID].comments.map(comment => {
          if (comment.id === commentID) {
            return {
              ...comment,
              scores: comment.scores.filter(x => x.id !== scoreID)
            }
          }
          return comment
        })
      }
    }
  },

  addFolderShare (state, { folderID, folderShare }) {
    state.folders.forEach(x => {
      if (x.id === folderID) {
        x.shares = x.shares.concat(folderShare)
        x.shared = true
      }
    })
    // TODO figure out why this isn't working
    // state.folders[folderID].shares = state.folders[folderID].shares.concat(folderShare)
  },
  addTeamFolderShare (state, { folderID, teamFolderShare }) {
    state.folders.forEach(x => {
      if (x.id === folderID) {
        x.teamshares = x.teamshares.concat(teamFolderShare)
        x.shared = true
      }
    })
  },
  removeFolderShare (state, { folderID, folderShareID }) {
    state.folders.forEach(x => {
      if (x.id === folderID) {
        x.shares = x.shares.filter(x => x.id !== folderShareID)
        if (x.shares.length > 0 || x.teamshares.length > 0) {
          x.shared = true
        } else {
          x.shared = false
        }
      }
    })
  },
  removeTeamFolderShare (state, { folderID, teamFolderShareID }) {
    state.folders.forEach(x => {
      if (x.id === folderID) {
        x.teamshares = x.teamshares.filter(x => x.id !== teamFolderShareID)
        if (x.shares.length > 0 || x.teamshares.length > 0) {
          x.shared = true
        } else {
          x.shared = false
        }
      }
    })
  },
  archiveUser (state, { userID, archive }) {
    state.group.users.forEach(x => {
      if (x.id === userID) {
        x.archived = archive
      }
    })
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/mutations.js